export { ProfileDropdownSummarySuspenseWrapper as ProfileDropdownSummary } from './profile-dropdown-summary-suspense-wrapper';
